import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {IconType, IoniconsFilled, PermissionDialog, PtEntity} from '@pt/pt-models';
import {ReminderPayload} from "./components";

@Component({
  selector: 'pt-details-page-header',
  template: `
    <div id="dph-side" class='dph-container' [attr.extended]="extended">
      <div class="w-100">
        <pt-icon class='dph-button' [size]='22'
                 [ngbTooltip]="'BUTTON.CLOSE' | translate"
                 [key]='IconClose' (click)='clickClose.emit()'
        ></pt-icon>
        <pt-icon class='dph-button' [size]='18'
                 [ngbTooltip]="'BUTTON.RELOAD' | translate"
                 [key]='IconRefresh' (click)='clickRefresh.emit()'
        ></pt-icon>
        <div class="dph-button" *ngIf="permissionDialog">
          <pt-permission-icon-button [permissionDialog]="permissionDialog"
                                     [color]="'#505050'"
          ></pt-permission-icon-button>
        </div>
        <pt-details-reminder class='dph-button'
                             [btnType]="'flat'"
                             [btnText]="btnText"
                             [showText]="showBtnReminderText"
                             [reminderPayload]="reminderPayload"
                             (reloadAction)="clickRefresh.emit()"
                             *ngIf="reminderPayload"
        ></pt-details-reminder>
      </div>

      <pt-icon id="icon-expand" class='dph-button dph-button--extends'
               triggers='mouseenter:mouseleave' placement='left' container='body'
               ngbPopover="{{extended ? ('BUTTON.REDUCE' | translate) : ('BUTTON.EXPAND' | translate)}}"
               [size]='18' [key]='extended ? IconReduce : IconExpand' (click)='clickFitContainer.emit()'
      ></pt-icon>

      <div class='dph-info'>
        <ng-content select='[detailHeaderAlertContent]'></ng-content>
        <div class="w-100">
          <div class="d-flex flex-row align-items-center">
            <div id="dph-title" class='dph-title me-1'>
              {{ title }}
            </div>
            <ng-content select='[additionalDetailTitleContent]'></ng-content>
          </div>
          <div class='dph-description'>{{ description }}</div>
        </div>
      </div>
    </div>

  `,
  styles: [`
    .dph-container {
      /*width: calc(100% - 65px);*/
      width: 100%;
      /*min-width: 600px;*/
      height: 70px;
      background: white;
      color: #505050;
      border-bottom: 1px solid #50505030;
    }

    .dph-button--extends {
      position: absolute;
      height: 70px;
      top: -10px;
      display: flex;
      align-items: center;
      color: #505050;
    }

    .dph-button--extends:hover {
      color: #bfbfbf;
    }

    .dph-button {
      float: right;
      cursor: pointer;
      color: #505050;
      margin: 10px 10px 0 0;
    }

    .dph-button:hover {
      color: #bfbfbf
    }

    .dph-title {
      font-size: 20px;
      /*width: calc(100% - 65px);*/
      max-width: 600px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .dph-description {
      font-size: 12px;
    }

    .dph-icon {
      display: inline-flex;
      /*background: black;*/
    }

    .dph-info {
      padding-left: 25px;
      align-items: center;
      height: 100%;
      display: flex;
      flex-direction: row;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `]
})
export class DetailsPageHeaderComponent implements OnChanges {

  @Input() image: string;
  @Input() entity: PtEntity;
  @Input() title: string;
  @Input() description: string;
  @Input() extended: boolean;
  @Input() opened: boolean;

  @Input() btnText: string;
  @Input() showBtnReminderText: boolean;
  @Input() reminderBtnType: 'btn' | 'flat' = 'flat';
  @Input() reminderPayload?: ReminderPayload;
  @Input() permissionDialog?: PermissionDialog;

  @Output() clickClose = new EventEmitter<boolean>();
  @Output() clickRefresh = new EventEmitter<boolean>();
  @Output() clickFitContainer = new EventEmitter<boolean>();

  IconClose = IoniconsFilled.close;
  IconRefresh = IoniconsFilled.refresh;
  IconFitContainer = IoniconsFilled.fitContainer;
  IconContract = IoniconsFilled.contract;

  IconExpand = IoniconsFilled.collapse;
  IconReduce = IoniconsFilled.expand;
  IconType = IconType;
  showIconAction = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes["opened"] && changes["opened"]?.currentValue) {
      const element = document.getElementById("dph-title");
      element?.focus({preventScroll: true});
    }
  }
}
